<template>
    <div>
        <buttonlist ref="SetBtn" @help="help" @search="search" @exps="exps"></buttonlist>
        <div>
            <table>
                <tr>
                    <td style="width:50px">{{$t('getapi[2484]')}}</td>
                    <td style="width:150px">
                        <el-select filterable v-model="iyear"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    <td style="width:50px">{{ $t('getapi[6345]') }}</td>
                    <td style="width:150px">
                        <el-select filterable v-model="imonth"  size="mini" style="margin-righ:20px">
                            <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <el-table
                    id="xpane-0"
                    :data="dataSet"
                    ref="singleTable"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="cost_year" :label="$t('getapi[1974]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="cost_month" :label="$t('getapi[1975]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[3437]')"></el-table-column>
                <el-table-column prop="sum_amount" :label="$t('getapi[6346]')" align="right">
                    <template slot-scope="scope">
                        {{scope.row.sum_amount | thousandth}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="vender_currency_code" :label="$t('getapi[3108]')"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_financedata',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                iyear: '',
                imonth: '',
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                yearList: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this
            that.userData = sessionStorage.getItem('userData');
            let year = new Date().getFullYear()
            for(let i=0;i<5;i++){
                that.yearList = [...that.yearList,{
                    value: year - i,
                    label: year - i
                }]
            }
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6344]"),this.$t("getapi[5132]"));
            },
//type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,export');
            },
            getView(){
                let that = this
                let parm = {
                    iyear: that.iyear,
                    imonth: that.imonth
                }
                that.$http.urlpost('/Pro/SchPro/GetFinanceDataView', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.dt;
                    }
                });
            },
            search(){
                let that = this
                that.getView()
            },
            exps(){
                let that = this;
                that.loading = true;
                let parm = {
                    iyear: that.iyear,
                    imonth: that.imonth,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[6344]')
                }
                that.$http.urlpost('/Pro/SchPro/GetFinanceDataToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
